import { EventEmitter, Injectable } from '@angular/core';
import { ConfiguracionInicialService } from './configuracioninicial.service';
import { ComunicacionapiService } from './comunicacionapi.service';
import { Constantes } from '../models/modules/Constantes';
import { Observable } from 'rxjs/internal/Observable';
import { Producto } from '../models/generic/Producto';
import { ProductosResumen } from '../models/generic/ProductosResumen';
import { AsesoresResumen } from '../models/generic/AsesoresResumen';
import { TopProductosResumen } from '../models/generic/TopProductosResumen';
import { ProductosResumenUsuarioMes } from '../models/generic/ProductosResumenUsuarioMes';
import { TopAfiliadosResumen } from '../models/generic/TopAfiliadosResumen';
import { TopCiudadesResumen } from '../models/generic/TopCiudadesResumen';
import { NuevosInactivosAfiliadosResumen_DTO } from '../models/generic/TopNuevosInactivosAfiliadosResumen';
import { TopAfiliadosPortafolioResumen_DTO } from '../models/generic/TopAfiliadosPortafolioResumen';
import { HeaderAdicionales } from '../models/generic/HeaderDatos';

@Injectable({
  providedIn: 'root'
})
export class ProductosService {
  
  ListaProductos: Producto[] = [];
  ListaProductosRegistro: Producto[] = [];
  ListaProductosCompletos: Producto[] = [];
  ListaProductosResumen: ProductosResumen[] = [];
  ListaProductosResumenUsuarioMes: ProductosResumenUsuarioMes[] = [];
  ListaAsesoresResumen: AsesoresResumen[] = [];
  ListaTopProductosResumen: TopProductosResumen[] = [];
  ListaTopAfiliadosResumen: TopAfiliadosResumen[] = [];
  ListaTopCiudadesResumen: TopCiudadesResumen[] = [];
  ListaTopNuevosInactivosAfiliadosResumen: NuevosInactivosAfiliadosResumen_DTO[] = [];
  ListaTopAfiliadosPortafolioResumen: TopAfiliadosPortafolioResumen_DTO[] = [];
  CantidadDiaria: number = 0;
  CantidadSemanal: number = 0;
  CantidadMensual: number = 0;
  CantidadEsperadaDiaria: number = 0;
  CantidadEsperadaSemanal: number = 0;
  CantidadEsperadaMensual: number = 0;
  ClaseDiaria: string = 'rainbow dia3';
  ClaseSemanal: string = 'rainbow semana1';
  ClaseMensual: string = 'rainbow mes1';
  public NotificarCambiarResumen: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  constructor(private configInicial: ConfiguracionInicialService,
    private comunicacionapiService: ComunicacionapiService) {
      
  }

  CargarProductos(parametros: any, origenConsulta: string): Observable<any> {
    console.log('CargarProductos', origenConsulta)
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarProductosVentas(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_CONSULTARVENTAS()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarProductosResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOSRESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarProductosResumenUsuarioMes(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOSRESUMENUSUARIOMES_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarAsesoresResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.ASESORESRESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarTopProductosResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.TOPPRODUCTOSRESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarTopAfiliadosResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.TOPAFILIADOSRESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarTopCiudadesResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.TOPCIUDADESRESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarTopNuevosInactivosAfiliadosResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.TOPNUEVOSINACTIVOSAFILIADOSRESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  CargarTopAfiliadosPortafolioResumen(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.TOPAFILIADOSPORTAFOLIORESUMEN_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Afiliado_Crear(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_AFILIAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  Afiliado_SubirArchivos(archivo: any, complemento: string): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_AFILIARARCHIVO()}/${complemento}`;
    return this.comunicacionapiService.Post(urlServicio, archivo);
  }
  Afiliado_Notificar(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_NOTIFICARAFILIAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarNroDocumento(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.AFILIACION_CONSULTAR()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarDatosAdicionalesAliado(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_CONSULTARDATOSADICIONALES()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarDatosNotificacionRegistro(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_DATOSNOTIFICACION_REGISTRO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  ConsultarDatosNotificacionCambioEstado(parametros: any): Observable<any> {
    let urlServicio: string = `${this.configInicial.ConfigLocal.UrlServicioDatos}${Constantes.PRODUCTOS_DATOSNOTIFICACION_CAMBIOESTADO()}`;
    return this.comunicacionapiService.Post(urlServicio, parametros);
  }
  VerificarCantidadDiaria(): string {
    let claseRetorno: string = '';
    if (this.CantidadEsperadaDiaria === 0) {
      return claseRetorno;
    } else if (this.CantidadDiaria === 0) {
      return claseRetorno;
    } else if (this.CantidadDiaria >= this.CantidadEsperadaDiaria) {
      return claseRetorno + ' hoy4';
    }

    let verificacionDato: number = (this.CantidadDiaria/this.CantidadEsperadaDiaria)*100;
    
    if (verificacionDato >= 0 && verificacionDato <= 25) {
      return claseRetorno + ' hoy1';
    } else if (verificacionDato >= 26 && verificacionDato <= 50) {
      return claseRetorno + ' hoy2';
    } else if (verificacionDato >= 51 && verificacionDato <= 90) {
      return claseRetorno + ' hoy3';
    } else if (verificacionDato >= 91) {
      return claseRetorno + ' hoy4';
    }

    return claseRetorno;
  }
  VerificarCantidadSemana(): string {
    let claseRetorno: string = '';
    if (this.CantidadEsperadaSemanal === 0) {
      return claseRetorno;
    } else if (this.CantidadSemanal === 0) {
      return claseRetorno;
    } else if (this.CantidadSemanal >= this.CantidadEsperadaSemanal) {
      return claseRetorno + ' semana4';
    }

    let verificacionDato: number = (this.CantidadSemanal/this.CantidadEsperadaSemanal)*100;

    if (verificacionDato >= 0 && verificacionDato <= 25) {
      return claseRetorno + ' semana1';
    } else if (verificacionDato >= 26 && verificacionDato <= 50) {
      return claseRetorno + ' semana2';
    } else if (verificacionDato >= 51 && verificacionDato <= 90) {
      return claseRetorno + ' semana3';
    } else if (verificacionDato >= 91) {
      return claseRetorno + ' semana4';
    }

    return claseRetorno;
  }
  VerificarCantidadMes(): string {
    let claseRetorno: string = '';
    if (this.CantidadEsperadaMensual === 0) {
      return claseRetorno;
    } else if (this.CantidadMensual === 0) {
      return claseRetorno;
    } else if (this.CantidadMensual >= this.CantidadEsperadaMensual) {
      return claseRetorno + ' mes4';
    }

    let verificacionDato: number = (this.CantidadMensual/this.CantidadEsperadaMensual)*100;

    if (verificacionDato >= 0 && verificacionDato <= 25) {
      return claseRetorno + ' mes1';
    } else if (verificacionDato >= 26 && verificacionDato <= 50) {
      return claseRetorno + ' mes2';
    } else if (verificacionDato >= 51 && verificacionDato <= 90) {
      return claseRetorno + ' mes3';
    } else if (verificacionDato >= 91) {
      return claseRetorno + ' mes4';
    }

    return claseRetorno;
  }
}
